import axios, { type AxiosResponse } from 'axios';

// Force localhost regardless of REACT_APP_API_BASE_URL.
// This page is a local-only dev tool — never hit production by accident.
const ExternalAPI = axios.create({ baseURL: 'http://localhost:8080' });

export const authorize = async (
  appId: string,
  appSecret: string,
): Promise<string> => {
  const { data } = await ExternalAPI.post(
    '/external/partner/v1/auth/authorize',
    {},
    { headers: { 'X-APP-ID': appId, 'X-APP-SECRET': appSecret } },
  );
  return data.data[0].accessToken as string;
};

export const invokeRealtime = (
  token: string,
  body: unknown,
): Promise<AxiosResponse<unknown>> =>
  ExternalAPI.post('/external/partner/v1/orders', body, {
    headers: { 'X-APP-AUTHORIZATION': token },
  });

export const invokeReservation = (
  token: string,
  body: unknown,
): Promise<AxiosResponse<unknown>> =>
  ExternalAPI.post('/external/partner/v1/orders/reserve', body, {
    headers: { 'X-APP-AUTHORIZATION': token },
  });

export const invokeTopUp = (
  token: string,
  body: unknown,
): Promise<AxiosResponse<unknown>> =>
  ExternalAPI.post('/external/partner/v1/orders/top-up', body, {
    headers: { 'X-APP-AUTHORIZATION': token },
  });
